import { AccountTypeEnum, ComplianceCaseTypeEnum } from "../../graphql/supergraphEnums";
import { ComplianceCaseTypeEnum as ComplianceCaseType } from "../../graphql/supergraphTypes";
import { isIndividualAccountType, isJoinAccountType } from "../../utils/account_types";
import { ComplianceContextValue } from "../ComplianceCaseContext";
import { InitialPage, InitialPageArgs } from "./types";

export const getInitialPage = (
  initialPageArgs: InitialPageArgs,
  readOnly: boolean = false,
): InitialPage => {
  const {
    accountType,
    iraConsentStatus,
    detailsCompleted,
    areOwnersCompleted,
    areControllersCompleted,
  } = initialPageArgs;

  if (!accountType) {
    return InitialPage.NoRootProfile;
  }

  if (isIndividualAccountType(accountType)) {
    return InitialPage.Individual;
  }
  if (accountType === AccountTypeEnum.Ira) {
    if (iraConsentStatus === true || readOnly) {
      return InitialPage.Individual;
    }
    if (iraConsentStatus === null) {
      return InitialPage.IraCategorization;
    }
  }

  if (isJoinAccountType(accountType)) {
    if (detailsCompleted && areOwnersCompleted) {
      return InitialPage.Tree;
    } else {
      return InitialPage.Joint;
    }
  }

  if (detailsCompleted && areOwnersCompleted && areControllersCompleted) {
    return InitialPage.Tree;
  }

  if (readOnly) {
    return InitialPage.Tree;
  }

  return InitialPage.Overview;
};

export const buildComponentContext = (
  arenaId: number,
  basePath: string,
  enableLPUXv2: boolean,
  caseDetails?: {
    id?: number;
    caseType?: ComplianceCaseType;
    investingProfileId?: number;
    programId?: number;
  },
  isReadOnly?: boolean,
): ComplianceContextValue => {
  return {
    basePath: basePath,
    caseId: caseDetails?.id || 0,
    caseType: caseDetails?.caseType || ComplianceCaseTypeEnum.InvestorOnboarding,
    arenaId: arenaId,
    rootProfileId: caseDetails?.investingProfileId || 0,
    // For IO case, the details would be freezed in the subscription flow itself.
    skipDetailsForRootProfile:
      caseDetails?.caseType === ComplianceCaseTypeEnum.InvestorOnboarding,
    programId: caseDetails?.programId || 0,
    enableLPUXv2: enableLPUXv2,
    isReadOnly: isReadOnly || false,
  };
};
